import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const VolunteerTypesConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/volunteer-types",
    component: React.lazy(() => import("./volunteer-types")),
  },
];
